import {
  Box,
  Button,
  // CircularProgress,
  // FormControl,
  // InputAdornment,
  // MenuItem,
  // Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
// import { getListAnswers } from "../services";
import { EmptyState } from "@shopify/polaris";
import emptyIMG from "../../../media/empty.png";
import { UpdatePoint } from "../services";
import CustomSnackbar from "components/snackbar";

interface TypedListAnswers {
  answers: Array<{
    index: number;
    answer: string;
  }>;
  createdAt: string;
  band_detail: { writing_point: number };
  test_id: {
    title: string;
  };
}
const style = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  px: 3,
  bgcolor: "#fff",
};
// const fakeData = [
//   {
//     index: 1,
//     answer:
//       "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
//   },
//   {
//     index: 2,
//     answer:
//       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
//   },
//   {
//     index: 3,
//     answer:
//       "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
//   },
//   {
//     index: 4,
//     answer:
//       'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.',
//   },
// ];

const GradingListAnswers = () => {
  const params = useParams();
  const location = useLocation();
  const answersData = location.state?.answers || [];
  const testType = location.state?.type || "reading";
  const { id } = params;
  const [point, setPoint] = React.useState<
    Array<{
      index: number;
      point: string;
    }>
  >([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  // const [loading, setLoading] = React.useState<boolean>(false);
  // React.useEffect(() => {
  //   setLoading(true);
  //   getListAnswers("65f7fce60376e8e576fc2d45").then((res: any) => {
  //     if (!res?.isError) {
  //       setListAnswers(res);
  //     } else {
  //       alert("error");
  //     }
  //     setLoading(false);
  //   });
  // }, []);
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleSave = React.useCallback(() => {
    const totalPoint = point.reduce(
      (total, item) => total + (parseFloat(item.point) || 0),
      0
    );

    const bandKey = `${testType}_point`;
    const band_detail = { [bandKey]: totalPoint };

    const data: { _id: string; band_detail: { [key: string]: number }; [key: string]: any } = {
      _id: id,
      band_detail,
    };

    if (testType === "writing") {
      data.writing_score_details = answersData.map((item, index) => ({
        index: item.index,
        score: String(point[index]?.point ?? ""),
      }));
    }

    UpdatePoint(data).then((res) => {
      if (!res.isError) {
        setSnackbarOpen(true);
        setSnackbarSeverity("success");
        setSnackbarMessage("Lưu thành công");
      } else {
        setSnackbarOpen(true);
        setSnackbarSeverity("error");
        setSnackbarMessage("Lưu thất bại");
      }
    });
  }, [point, id, testType]);
  const renderListAnswers = () => {
    return (
      <>
        {answersData.map((item, index) => (
          <Stack key={index} gap={"4px"} mt={1}>
            <Typography variant="body1" fontWeight={600}>
              Câu {item.index}
            </Typography>
            <Typography variant="subtitle1">{item.answer}</Typography>
          </Stack>
        ))}
      </>
    );
  };
  const renderListGrading = () => {
    return (
      <Stack gap={2} mt={1}>
        {answersData.map((item, index) => (
          <Stack key={index} direction={"row"} gap={2} alignItems={"center"}>
            <Typography variant="body1" fontWeight={600}>
              Câu {item.index}
            </Typography>
            <TextFieldWithSelectInputAdornment
              point={point}
              setPoint={setPoint}
              index={index}
              indexAnswer={item.index}
            />
          </Stack>
        ))}
      </Stack>
    );
  };
  if (answersData.length == 0)
    return <EmptyState heading="Không có câu trả lời nào!" image={emptyIMG} />;
  // if (loading)
  //   return (
  //     <Box
  //       sx={{
  //         display: "flex",
  //         flex: 1,
  //         flexDirection: "column",
  //         alignItems: "center",
  //       }}
  //     >
  //       <CircularProgress size={24} />
  //     </Box>
  //   );
  return (
    <Box sx={style}>
      <Box
        sx={{
          display: "flex",

          maxHeight: "95vh",
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            width: "70%",
            borderWidth: "0px 1px 0px 0px",
            borderStyle: "solid",
            padding: "16px 0px 16px 16px",
            borderColor: "#e3e3e3",
          }}
        >
          <Typography variant="h6" fontWeight={600} color={"primary"}>
            Bài thi
          </Typography>
          {renderListAnswers()}
        </Box>
        <Box
          sx={{
            overflowY: "auto",
            width: "30%",
            px: 3,
            padding: "16px 0px 16px 16px",
          }}
        >
          <Typography variant="h6" fontWeight={600} color={"primary"}>
            Chấm thi
          </Typography>

          {renderListGrading()}
          <Button
            sx={{
              position: "fixed",
              bottom: "32px",
              right: "16px",
            }}
            variant="contained"
            color="primary"
            onClick={handleSave}
          >
            Lưu
          </Button>
        </Box>
      </Box>
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};

const TextFieldWithSelectInputAdornment: React.FC<{
  index: number;
  indexAnswer: number;
  point: any;
  setPoint: React.Dispatch<any>;
}> = ({ index, point, setPoint, indexAnswer }) => {
  // const [unit, setUnit] = React.useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPoint((prev) => {
      const newPoint = [...prev];
      if (!newPoint[index]) {
        newPoint[index] = { index: indexAnswer, point: 0 };
      }
      newPoint[index].point = event.target.value;
      return newPoint;
    });
  };

  return (
    <TextField
      variant="outlined"
      label={`Nhập điểm câu ${indexAnswer}`}
      value={point[index]?.point}
      sx={{
        "& .MuiInputBase-root.MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: !!point[index]?.point && "green",
          },
          pr: 0,
        },
      }}
      placeholder={"VD: 1.23"}
      onChange={handleChange}
      type="number"
      // InputProps={{
      //   endAdornment: (
      //     <InputAdornment position="end">
      //       <FormControl sx={{ minWidth: 80 }}>
      //         <Select
      //           id="demo-simple-select-helper"
      //           value={unit}
      //           onChange={handleChange}
      //           sx={{
      //             borderTopLeftRadius: 0,
      //             borderBottomLeftRadius: 0,
      //           }}
      //           // InputLabelProps={{
      //           //   shrink: false,
      //           //   sx: { display: "none" },
      //           // }}
      //         >
      //           <MenuItem value={"Bytes"}>Bytes</MenuItem>
      //           <MenuItem value={"KiB"}>KiB</MenuItem>
      //           <MenuItem value={"GiB"}>GiB</MenuItem>
      //           <MenuItem value={"MiB"}>MiB</MenuItem>
      //         </Select>
      //       </FormControl>
      //     </InputAdornment>
      //   ),
      // }}
    />
  );
};
export default GradingListAnswers;
